import { IApplicationState } from '../../types/redux';

export const selectWidgetBrokerParams = (state: IApplicationState) => {
  const accountLegalType = state.brokerAvailability?.accountLegalType;
  const hasConfirmedPhone = state.brokerAvailability?.hasConfirmedPhone;

  if (accountLegalType && hasConfirmedPhone) {
    return { accountLegalType, hasConfirmedPhone };
  }

  return null;
};
